import { atom } from "jotai";

export const fontsAtom = atom<IFont[]>([]);

export interface IFont {
    id?: number;
    name: string;
    file_name: string;
    fnt_name: string;
}